import { render, staticRenderFns } from "./MRC_ESS_StaffAvatar.vue?vue&type=template&id=ce7a5f04&"
import script from "./MRC_ESS_StaffAvatar.vue?vue&type=script&lang=js&"
export * from "./MRC_ESS_StaffAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAvatar,VBadge,VImg,VProgressCircular,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce7a5f04')) {
      api.createRecord('ce7a5f04', component.options)
    } else {
      api.reload('ce7a5f04', component.options)
    }
    module.hot.accept("./MRC_ESS_StaffAvatar.vue?vue&type=template&id=ce7a5f04&", function () {
      api.rerender('ce7a5f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MRC_ESS_StaffAvatar.vue"
export default component.exports